export default "__VITE_ASSET__BVPVTKx1__"